export default "__VITE_ASSET__Gk_wqeDu__"